export default "__VITE_ASSET__34e55489__"